.container {
  color: var(--color-grayscale-light-slate);
  white-space: pre-line;
}
